import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { getOrders, selectOrders } from '../../orders/orders';
import { selectServices } from '../../app/services';
import Icon from '../../../ui/Icon';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from '../../app/containers/IsSpinning';
import Order from '../../orders/components/Order';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Orders.scss';
import Table from '../../../ui/Table';
import Button from '../../../ui/Button';


export class Dashboard extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        orders: ImmutablePropTypes.orderedMap.isRequired,
        services: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.dispatch(getOrders());
    }

    render() {
        const { orders, services, spinner } = this.props;

        return (
            <div>
                <Table>
                    <Table.Row type='header' className={styles.headerRow}>
                        <Table.Cell className={styles.headerCell}>Bestellung</Table.Cell>
                        <Table.Cell className={styles.headerCell}>Erstellt</Table.Cell>
                        <Table.Cell className={styles.headerCell}>Service</Table.Cell>
                        <Table.Cell className={styles.headerCell}>Aktueller Status</Table.Cell>
                    </Table.Row>
                    {
                        orders.size === 0 && !spinner.get('orders') ?
                            (<div className={styles.emptyContainer} key={'0'}>
                                <h3>
                                    <FormattedMessage id='frontend.orders.dashboard.no_orders' />
                                </h3>
                            </div>) :
                            orders.slice(0, 10).map(order => <Order
                                key={order.get('id')}
                                order={order}
                                services={services}
                            />).toArray()
                    }
                </Table>
                <IsSpinning id='orders'>
                    <div className={styles.loadingMessage}>
                        <Icon name='refresh' spin fixedWidth />{' '}
                        <FormattedMessage id='common.helper.please_wait' />
                    </div>
                </IsSpinning>
                {(orders.size > 0) ? (
                    <Button link to='/orders' emphasis='primary' standalone>
                        <FormattedMessage id='frontend.orders.dashboard.display_all' />
                    </Button>) : null}
                {(orders.size === 0 && !spinner.get('orders')) ? (
                    <Button link to='/order/region' emphasis='primary'>
                        <FormattedMessage id='frontend.orders.dashboard.new_order' />
                    </Button>) : null}
            </div>
        );
    }
}

export default connect(state => ({
    orders: selectOrders(state),
    services: selectServices(state),
    spinner: state.spinner,
}))(Dashboard);
